"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _GradeTypeConstants = _interopRequireDefault(require("../constants/GradeTypeConstants"));

var _ScoreUtil = _interopRequireDefault(require("../util/ScoreUtil"));

var Score =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Score, _React$Component);

  function Score() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Score);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Score)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getScoreClassName = function (scorePercentage) {
      var gradeType = _ScoreUtil.default.getOverallGradeType(scorePercentage);

      return (0, _classnames.default)({
        'score-container': true,
        'score-container-good': gradeType === _GradeTypeConstants.default.GREAT || gradeType === _GradeTypeConstants.default.GOOD,
        'score-container-ok': gradeType === _GradeTypeConstants.default.OK,
        'score-container-bad': gradeType === _GradeTypeConstants.default.BAD
      });
    };

    return _this;
  }

  (0, _createClass2.default)(Score, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onClick = _this$props.onClick,
          scorePercentage = _this$props.scorePercentage,
          scoreStyle = _this$props.scoreStyle;
      return _react.default.createElement("div", {
        className: this.getScoreClassName(scorePercentage),
        onClick: onClick,
        style: scoreStyle
      }, children);
    }
  }]);
  return Score;
}(_react.default.Component);

exports.default = Score;
Score.propTypes = {
  children: _propTypes.default.node.isRequired,
  onClick: _propTypes.default.func,
  scorePercentage: _propTypes.default.number.isRequired,
  scoreStyle: _propTypes.default.object
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/Score.js
// module id = 153
// module chunks = 0